import { mapState } from 'vuex';
import { localizeDate } from '@/utils/date';
import NiotaClassicApiService from '@/services/niotaClassicApiService';
import formMixin from '../formMixin';
const defaultItemsPerPage = 15;
export default {
  name: 'NiotaClassicConsumersApplTable',
  mixins: [formMixin],
  props: {
    applications: {
      type: undefined,
      required: true
    },
    dense: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      lclObject: {},
      dialogAdd: false,
      selectedApplication: null,
      isFetching: null,
      applicationsSelection: [],
      tableOptions: {
        sortBy: ['id'],
        sortDesc: [false],
        itemsPerPage: defaultItemsPerPage
      },
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      }
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    tableHeadersUI() {
      let res = [{
        text: 'ID',
        value: 'id',
        align: 'center'
      }, {
        sortable: false
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.title'),
        value: 'applicationTitle',
        align: 'left'
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.createdAt'),
        value: 'applicationCreatedAt'
      }, ...(this.isIotHubManager ? [{
        align: 'end',
        sortable: false
      }] : [])];
      if (this.dense) {
        res.splice(1, 1);
      }
      return res;
    }
  },
  created() {
    this.isFetching = true;
    NiotaClassicApiService.applicationsFetchPlain().then(res => {
      this.applicationsSelection = res.data.applications;
    }).catch(error => {
      // TODO: create toast with error message
      console.error('Could not fetch applications', error);
    }).finally(() => {
      this.isFetching = false;
    });
  },
  methods: {
    localizeDate,
    deleteLine(application) {
      let editedIndex = this.applications.indexOf(application);
      this.applications.splice(editedIndex, 1);
    },
    addItem() {
      let a = {};
      a.applicationId = this.selectedApplication.id;
      a.applicationTitle = this.selectedApplication.title;
      a.applicationImage = this.selectedApplication.image;
      if (!this.applications) {
        this.applications = [];
      }
      this.applications.push(a);
      this.selectedApplication = {};
      this.dialogAdd = false;
    }
  }
};